import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const IFrameContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const IFrame = styled.iframe`
  border: none;
  max-width: 100%;
  margin: 0;
`;

export const QuizContainer = styled(Stack)`
  padding: 100% 0 0 0;
  width: 100%;
`;
